import React from 'react';
import { Form } from 'react-bootstrap';
import { Character } from '../../../../../dorian-shared/types/character/Character';
import {
  DEFAULT_CHARACTER_MEMORY_PRESENTATION_LABEL,
  isCharacterReferenceMemoryType,
  MemoryType,
  MemoryValue,
  SELECT_CHARACTER_MEMORY_PRESENTATION_PLACEHOLDER,
} from '../memoryBankTypes';
import classes from './MemoryField.module.scss';

interface MemoryValueFieldBase extends React.ComponentProps<typeof Form.Control> {
    id: string;
    value: MemoryValue;
}

/** Memory types whose value is a character id. */
type CharacterMemoryType = MemoryType.Character;

interface MemoryValueFieldWithCharacters extends MemoryValueFieldBase {
    type: CharacterMemoryType;
    characters: Character[] | null;
}

interface MemoryValueFieldWithoutCharacters extends MemoryValueFieldBase {
    type: Exclude<MemoryType, CharacterMemoryType>;
    characters: Character[] | null;
}

export type MemoryValueFieldProps = MemoryValueFieldWithCharacters | MemoryValueFieldWithoutCharacters;

export function MemoryValueField(props: MemoryValueFieldProps) {
  const {
    type,
    id,
    value,
    characters,
    errorMessage,
    ...rest
  } = props;

  const isCharacterMemoryPresentationSelectionType = isCharacterReferenceMemoryType(type);
  const valueLabel = isCharacterMemoryPresentationSelectionType ? DEFAULT_CHARACTER_MEMORY_PRESENTATION_LABEL : 'Value';

  return (
    <Form.Group className="position-relative">
      <Form.Label
        htmlFor={id}
        className={classes.memoryLabel}
      >
        {valueLabel}
      </Form.Label>
      {(type === MemoryType.String || type === MemoryType.Number)
          && (
          <Form.Control
            id={id}
            type={type === MemoryType.Number ? 'number' : 'text'}
            value={value}
            placeholder={type === MemoryType.Number ? 'Enter number' : 'Enter string'}
            {...rest}
          />
          )}
      {type === MemoryType.Boolean
            && (
            <Form.Control
              as="select"
              required
              id={id}
              value={value}
              {...rest}
            >
              <option value="" disabled>[select default]</option>
              <option value="true">Yes</option>
              <option value="false">No</option>
            </Form.Control>
            )}
      {isCharacterReferenceMemoryType(type)
            && (
            <Form.Control
              as="select"
              required
              id={id}
              value={value}
              {...rest}
            >
              {!characters
                ? <option value="loading">loading...</option>
                : (
                  <>
                    <option value="" disabled>{SELECT_CHARACTER_MEMORY_PRESENTATION_PLACEHOLDER}</option>
                    {characters.map((character) => (
                      <option value={character.id} key={character.id}>
                        {character.alias}
                      </option>
                    ))}
                  </>
                )}
            </Form.Control>
            )}
      <Form.Control.Feedback type="invalid" tooltip>
        {errorMessage}
      </Form.Control.Feedback>
    </Form.Group>
  );
}
